<template>
    <ul v-bind:class="{'steps-list': true, 'greyed': lead.isUDSelling}">
        <li v-bind:class="{'active':!lead.advancePet,'completed':lead.advancePet}">
            <div class="steps-list__icon" v-html="lead.advancePetIcon"></div>
            <div class="steps-list__txt"><strong>Angaben zum Tier</strong>
            <span  v-bind:class="{'steps-list__info-edit':true,'show':lead.advancePet}" v-if="!lead.isUDSelling">
                  <i class="icon-pen" v-on:click="$parent.back(1, 'tier')"></i>
                </span>
            <div v-bind:class="{'steps-list__info':true,'show':lead.advancePet}">
               <div v-bind:class="{'steps-list__info-item':true, 'show':lead.advancePet}">
                  <span>{{ lead.petname }}</span>
                  <span>{{ lead.petgender | setgender }}, {{ lead.breed }}</span>
                  <span>geboren am {{ lead.petbirthday | sortdate }}</span>
                </div>

              </div>
            </div>
        </li>
       <li v-bind:class="{'active': lead.advancePet, 'completed':lead.advancePerson}">
            <div class="steps-list__icon" v-html="lead.advancePersonIcon"></div>
            <div class="steps-list__txt"><strong>Persönliche Daten</strong>
            <span  v-bind:class="{'steps-list__info-edit':true,'show':lead.advancePerson}" v-if="!lead.isUDSelling">
                  <i class="icon-pen" v-on:click="$parent.back(2, 'persoenliche-daten')"></i>
                </span>
            <div v-bind:class="{'steps-list__info':true,'show':lead.advancePerson}">
               <div v-bind:class="{'steps-list__info-item':true,'show':lead.advancePerson}">
                  <span>{{ lead.gender }} {{ lead.firstname }} {{ lead.lastname }}</span>
                  <span>geboren am {{ lead.birthday | sortdate }}</span>
                  <span>{{ lead.phone }}</span>
                  <span>{{ lead.email }}</span>
                </div>
                 <div v-bind:class="{'steps-list__info-item':true,'show':lead.advancePerson}">
                  <span>{{ lead.street }} {{ lead.number }}</span>
                  <span>{{ lead.zip }} {{ lead.city }}</span>
                  <span>{{ lead.country }}</span>
                </div>

              </div>
            </div>
        </li>
      <li v-bind:class="{'active':lead.advancePerson,'completed':lead.advanceHealth || lead.isUDSelling, 'greyed': lead.isUDSelling}" v-if="!isHPS(lead)">
        <div class="steps-list__icon" v-html="lead.isUDSelling ? lead.advancePetIcon : lead.advanceHealthIcon"></div>
        <div class="steps-list__txt"><strong>Gesundheit des Tieres</strong>
          <span  v-bind:class="{'steps-list__info-edit':true,'show':lead.advanceHealth}" v-if="!lead.isUDSelling">
                  <i class="icon-pen" v-on:click="$parent.back(2, 'gesundheit')"></i>
                </span>
          <div v-bind:class="{'steps-list__info':true,'show':lead.advanceHealth || lead.isUDSelling}">
            <div v-bind:class="{'steps-list__info-item':true, 'show':lead.advanceHealth || lead.isUDSelling}">
              <span>Vorerkrankungen: {{ lead.treatmentBase == 1 && lead.healthElements && lead.healthElements.length ? lead.healthElements.map(obj => obj.description || obj.preCondition.name).join(', ') : 'keine' }}</span>
              <span>Symptome: {{ lead.symptomElements && lead.symptomElements.length ? lead.symptomElements.map(obj => obj.name).join(', ') : 'keine' }}</span>
            </div>
          </div>
        </div>
      </li>
        <li v-bind:class="{'active':isHPS(lead) ? lead.advancePerson : lead.advanceHealth,'completed':lead.advancePayment}" >
            <div class="steps-list__icon" v-html="lead.advancePaymentIcon"></div>
            <div class="steps-list__txt"><strong>Zahlung</strong>
            <span  v-bind:class="{'steps-list__info-edit':true,'show':lead.advancePayment}">
                  <i class="icon-pen" v-on:click="$parent.back(isHPS(lead) ? 3 : 4, 'zahlung')"></i>
                </span>
              <div v-bind:class="{'steps-list__info':true,'show':lead.advancePayment}">
                <div v-bind:class="{'steps-list__info-item':true,'show':lead.advancePayment}">
                  <span>{{ lead.productName }}</span>
                  <span>{{ lead.productPrice }} € monatlich</span>
                  <span>Vertragsbeginn: {{ lead.startDate | sortdate }}</span>
                  <span>{{ lead.paymentinterval | paymentInterval }} Zahlung</span>
                  <span>{{ lead.paymentType | completePaymentType }}</span>
                </div>

              </div>
            </div>
        </li>
        <li>
            <div class="steps-list__icon"></div>
            <div class="steps-list__txt"><strong>Zusammenfassung</strong></div>
        </li>
    </ul>
</template>
<script>
export default ({
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        lead: {
            type: Object,
            default() {
                return {}
        }}
    }
})
</script>


<style scoped>
.steps-list li .steps-list__info-item {
    display:none;
}
.steps-list__info-edit {
    display:none !important;
}
.show { display:block !important}

.steps-list.greyed li .steps-list__icon::after {
  background:#6b6b6b;
}
.steps-list.greyed li.completed .steps-list__icon {
  background-color: #6b6b6b;
}
.steps-list.greyed li.active .steps-list__icon {
  border-color: #6b6b6b;
}
#sidebar .greyed {
  color: #6b6b6b
}
</style>
